import { Component, ChangeDetectionStrategy } from '@angular/core';

import { PermissionEnum } from '@app/generated/graphql';
import { IsoWeekService } from '@app/core/services/isoWeek.service';
import { NavService } from '@app/core/services/nav.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationComponent {
  permissionEnum = PermissionEnum;

  constructor(
    public navService: NavService,
    public isoWeekService: IsoWeekService,
  ) {}
}
